export interface NavigationItem {
  label: string;
  href: string;
}

export const navigationConfig: NavigationItem[] = [
  { label: "Accueil", href: "/" },
  { label: "Nos Châteaux", href: "/chateaux" },
  { label: "Sumos", href: "/sumos" },
  { label: "FAQ", href: "/faq" },
  { label: "Contact", href: "/#contact" },
  { label: "Blog", href: "/blog" },
];

export const logoConfig = {
  src: "/lovable-uploads/logo-80.webp",
  alt: "Logo Château de Clémentine",
  title: "Château de Clémentine",
  subtitle: "Location depuis 1993"
};